import { apiV4 } from './utils';

export const orderActivate = (body) =>
  apiV4({
    method: 'POST',
    url: 'order/activate',
    body,
  });

export const orderStatus = (orderNumber) =>
  apiV4({
    method: 'GET',
    url: `/order/${orderNumber}/status`,
  });

export const updateEquipmentNames = ({ orderNumber, equipment }) =>
  apiV4({
    method: 'PUT',
    url: `/order/${orderNumber}/equipment/location-names`,
    body: { equipment },
  });

export const updateVerbalPassword = ({ orderNumber, verbalPassword }) =>
  apiV4({
    method: 'PUT',
    url: `/order/${orderNumber}/verbal-password`,
    body: { verbalPassword },
  });

export const checkout = (order) =>
  apiV4({
    method: 'POST',
    url: '/order',
    body: order,
  });

/**
 *
 * @param {string} checkoutToken
 * @returns
 */
export const verifyAffirm = (checkoutToken) =>
  apiV4({
    method: 'POST',
    url: '/payment-form/verify-affirm',
    body: {
      checkoutToken,
    },
  });

/**
 *
 * @param {string} affirmId
 * @returns
 */
export const voidAffirm = (affirmId) =>
  apiV4({
    method: 'POST',
    url: '/payment-form/void-affirm',
    body: {
      affirmId,
    },
  });
